import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { TOfferSetType } from './getOfferSetType';

export const ApprovalHeader = ({
    offerSetType
}: {
    offerSetType: TOfferSetType;
}) => {
    if (
        offerSetType === 'repayment_reduction_only' ||
        offerSetType === 'repayment_reduction_with_choice'
    ) {
        return (
            <div className="space-y-s">
                <h2 className="m-0 text-2xl">
                    <FormattedMessage
                        id="_.topup_choice.reduce_your_min_monthly_repayments_title"
                        defaultMessage="Reduce your min. monthly repayments"
                    />
                </h2>
                <Text>
                    <FormattedMessage
                        id="_.topup_choice.reduce_your_min_monthly_repayments_description"
                        defaultMessage="Lower monthly repayments by extending your loan while maintaining the balance."
                    />
                </Text>
            </div>
        );
    }

    return (
        <div className="space-y-s">
            <h2 className="m-0 text-2xl">
                <FormattedMessage
                    id="_.topup_choice.withdraw_additional_funds_title"
                    defaultMessage="Withdraw additional funds"
                />
            </h2>
            <Text>
                <FormattedMessage
                    id="_.topup_choice.withdraw_additional_funds_description"
                    defaultMessage="Access additional cash and start a new term, replacing your current one."
                />
            </Text>
        </div>
    );
};
